import useFetch from '@hooks/useFetch';
import { getCMSHost } from '@utils/api-helper/host';
import getSubscriptionCmsKey from '@utils/subscriptionHelpers/getSubscriptionCmsKey';

const CMSHost = getCMSHost();

export const getSubsriptionFeaturesKey = (
  goalUid,
  isIconicProAvailable = false
) =>
  `${CMSHost}subscription-features/${getSubscriptionCmsKey(
    goalUid,
    isIconicProAvailable
  )}`;

const useSubsriptionFeatures = (goalUID, isIconicProAvailable = false) => {
  const { data, ...rest } = useFetch(
    getSubsriptionFeaturesKey(goalUID, isIconicProAvailable),
    {
      useAuthToken: false
    }
  );
  return { subscriptionData: data, ...rest };
};

export default useSubsriptionFeatures;
